import React from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { logout, logoutComplete } from "../../../redux/slice/userSlice";
import {
  FaHistory,
  FaHome,
  FaRegUserCircle,
  FaSignOutAlt,
  FaTrophy,
} from "react-icons/fa";

const SideBar = () => {
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    dispatch(logoutComplete());
  };

  const activeLink =
    "h-14 rounded-md font-medium flex flex-row sm:gap-6 gap-3 sm:pl-8 pl-5 items-center text-secondary bg-secondary/20";
  const inActiveLink =
    "h-14 rounded-md font-medium flex flex-row sm:gap-6 gap-3 sm:pl-8 pl-5 items-center text-secondary hover:bg-secondary/20 hover:ease-in transition duration-100";

  return (
    <section className="flex flex-col gap-3 sm:w-[200px] w-[170px] h-full">
      <NavLink
        to="/client/home"
        className={({ isActive }) => (isActive ? activeLink : inActiveLink)}
      >
        <FaHome />
        <span>Home</span>
      </NavLink>
      <NavLink
        to="/client/profile"
        className={({ isActive }) => (isActive ? activeLink : inActiveLink)}
      >
        <FaRegUserCircle />
        <span>Profile</span>
      </NavLink>
      <NavLink
        to="/client/history"
        className={({ isActive }) => (isActive ? activeLink : inActiveLink)}
      >
        <FaHistory />
        <span>History</span>
      </NavLink>
      <NavLink
        to="/client/leaderboard"
        className={({ isActive }) => (isActive ? activeLink : inActiveLink)}
      >
        <FaTrophy />
        <span>Leaderboard</span>
      </NavLink>

      <button
        onClick={handleLogout}
        type="button"
        className={`${inActiveLink}`}
      >
        <FaSignOutAlt />
        <span>Logout </span>
      </button>
    </section>
  );
};

export default SideBar;
